import { render, staticRenderFns } from "./ClientIdRegenerateConfirmModal.vue?vue&type=template&id=143a89b6&scoped=true&"
import script from "./ClientIdRegenerateConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ClientIdRegenerateConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a89b6",
  null
  
)

export default component.exports